// Core
import React from 'react';

// Components
import { Col } from '../../../../../../layout/elements/Col';
import { Row } from '../../../../../../layout/elements/Row';

// Modules
import { ControlMode } from './Modules/ControlMode/ControlMode';
import { Information } from './Modules/Information';
import { Sensors } from './Modules/Sensors';

// Component
import { Container, Separator } from './Setup.style';
import { SetupProps } from './Setup.types';

function Setup({
  className,
  unitData,
  edgeStatus,
  testId,
}: SetupProps): JSX.Element {
  return (
    <Container className={className} data-testid={testId}>
      <Row>
        <Col>
          <Information
            unitData={unitData}
            edgeStatus={edgeStatus}
          />
          <Separator />
          <Row style={{ rowGap: 16 }}>
            <Col cols={24} xl={6}>
              <ControlMode unitData={unitData} edgeStatus={edgeStatus} />
            </Col>
            <Col cols={24} xl={18}>
              <Sensors unitData={unitData} edgeStatus={edgeStatus} />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export { Setup };
